import { render, staticRenderFns } from "./ManageExtendPhaseTerm.vue?vue&type=template&id=6bb6e28d"
import script from "./ManageExtendPhaseTerm.vue?vue&type=script&lang=js"
export * from "./ManageExtendPhaseTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports